<template>
  <WebsiteSelectionGrid
    :items="offers"
    title="Angebote"
    description="Wähle die Angebote, die für dieses Studio auf der Webseite sichtbar sein sollen."
    icon="mdi-tag-multiple-outline"
    fallback-icon="mdi-star-outline"
    empty-title="Keine Angebote vorhanden"
    empty-text="Aktuell stehen keine Angebote zur Auswahl."
    @toggle="handleToggle" />
</template>

<script>
import api from "@/api"
import WebsiteSelectionGrid from "./WebsiteSelectionGrid.vue"

export default {
  components: { WebsiteSelectionGrid },
  data() {
    return { offers: [] }
  },
  created() {
    this.fetchOffers()
  },
  methods: {
    async fetchOffers() {
      try {
        this.offers = await api.fetchOffers()
      } catch (error) {
        this.$toast.error("Fehler beim Laden der Angebote.")
      }
    },
    handleToggle(item) {
      item.isSelected = !item.isSelected
      this.toggleStudio(item._id, item.isSelected)
    },
    async toggleStudio(id, isSelected) {
      try {
        await api.toggleOfferService(id, isSelected ? "add" : "remove")
      } catch (error) {
        this.$toast.error("Änderung konnte nicht gespeichert werden.")
        const item = this.offers.find((entry) => entry._id === id)
        if (item) item.isSelected = !isSelected
      }
    },
  },
}
</script>
